export default "__VITE_ASSET__BjeootnE__"